module.exports = __webpack_public_path__ + "img/azienda-hdtool.f19e85d6.png";